/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import store from '@/store/';
import router from '@/router/router';
import {
  serialize,
} from '@/util/util';
import {
  getToken
} from '@/util/auth';
import {
  Message
} from 'element-ui';
import website from '@/config/website';
import {
  Base64
} from 'js-base64';
// import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';
axios.defaults.baseURL = process.env.API_BASE_URL
//默认超时时间
// axios.defaults.timeout = 30000;
//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// NProgress 配置
// NProgress.configure({
//   showSpinner: false
// });

//http request拦截
axios.interceptors.request.use(config => {
  // console.log(config, "configconfig")
  config.timeout = config.timeout || 30000
  //开启 progress bar
  // NProgress.start();
  const meta = (config.meta || {});
  // const isToken = meta.isToken === false;
  // config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
  //让每个请求携带token
  // console.log(getToken() , ",,,,```getToken() ")
  const noCookieList = website.noCookieList || [];
  if (!noCookieList.includes(config.url) && getToken('token') ){
    config.headers['Authorization'] = `JWT ${getToken('token')}`;
  }
  //headers中配置text请求
  config.headers['Content-Type'] = 'application/json';
  if (config.text === true) {
    config.headers['Content-Type'] = 'text/plain';
  }
  if (config.type === 'form') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // console.log(config.data, '111config.data')
    config.data = serialize(config.data);
  }

  //headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }
  return config;
}, error => {
  return Promise.reject(error);
});
//http response 拦截
axios.interceptors.response.use(res => {
  //关闭 progress bar
  // NProgress.done();
  //获取状态码
  const status = res.data.code || res.status;
  const statusWhiteList = website.statusWhiteList || [];
  const message = res.data.msg || res.data.error_description || '未知错误';
  //如果在白名单里则自行catch逻辑处理
  if (statusWhiteList.includes(status)) return Promise.reject(res);
  //如果是401则跳转到登录页面
  if (status === 401) {
    // store.dispatch('FedLogOut').then(() => router.push({
    //   path: '/login'
    // }));
    console.log('401');
    return Promise.reject(new Error(res))
  }
  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    // url白名单自行逻辑处理
    const url = res.config.url
    const urlWhiteList = website.urlWhiteList || [];
    if (urlWhiteList.includes(url)) return Promise.reject(res);
    if (typeof res.config.errorCallback === 'function') { // 可临时处理接口回调
      res.config.errorCallback(res.data)
      return Promise.reject(res);
    }
    const data = res.data || {};
    let errorMsg = '操作失败';

    if (data.message) {
      // 你后端统一格式 { status, message, errors }
      errorMsg = data.message;
    } else {
      // DRF 默认格式 { username: ["xxx"], phone: ["yyy"] }
      const firstKey = Object.keys(data)[0];
      if (firstKey) {
        const val = data[firstKey];
        errorMsg = Array.isArray(val) ? val[0] : String(val);
      }
    }
    Message({
      message: errorMsg,
      type: 'error'
    });
    
    
    return Promise.reject(res);
  }
  if (res.config.noCode) return res.data.data
  return res;
}, error => {
  // NProgress.done();
  // router.push({
  //   path: '/405'
  // });
  console.log("fuwuqicuowu")
  return Promise.reject(new Error(error));
});

export default axios;



// WEBPACK FOOTER //
// ./src/router/axios.js